/**
 * 该文件存放一些不需要token的页面路由
 */

const noTokenRoutes = [
  // 登录页
  {
    path: '/login',
    name: 'Login',
    meta: {
      ignoreToken: true,
    },
    component: () => import('@/pages/login/login')
  },
  // 忘记密码页
  {
    path: '/forget-password',
    name: 'ForgetPassword',
    meta: {
      ignoreToken: true,
    },
    component: () => import('@/pages/forget-password/forget-password')
  },
  // 非会员注册页面
  {
    path: '/non-user-register',
    name: 'NonUserRegister',
    meta: {
      ignoreToken: true,
    },
    component: () => import('@/pages/register/register-non-user')
  },
  // 非会员注册成功页面
  {
    path: '/non-user-register-success',
    name: 'NonUserRegisterSuccess',
    meta: {
      ignoreToken: true,
    },
    component: () => import('@/pages/register/register-non-user-succ')
  },
  // 首营开通申请页面 v3.2.0
  {
    path: '/apply',
    name: 'Apply',
    meta: {
      ignoreToken: true,
    },
    component: () => import('@/pages/apply/apply')
  },
  // 变更超管页面
  {
    path: '/change-admin',
    name: 'ChangeAdmin',
    meta: {
      ignoreToken: true,
    },
    component: () => import('@/pages/change-admin')
  },
  // 账号注销成功
  {
    path: '/account-cancel-success',
    name: 'AccountCancelSuccess',
    meta: {
      ignoreToken: true,
    },
    component: () => import('@/pages/account-cancellation/cancel-success')
  },
  // 微信支付
  {
    path: '/wechatPay',
    name: 'WechatPay',
    meta: {
      menuName: 'WechatPay',
      ignoreToken: true,
    },
    component: () => import('@/pages/wechatPay/wechatPay')
  },
  // 首营查看多个pdf页面
  {
    path: '/display-pdf',
    name: 'DisplayPdf',
    meta: {
      ignoreToken: true,
    },
    component: () => import('@/pages/display-pdf')
  },
  // 上传图片转换成pdf文件的
  {
    path: '/transform-img-to-pdf',
    name: 'TransfromImg2Pdf',
    meta: {
      ignoreToken: true,
    },
    component: () => import('@/pages/transfrom-to-pdf/index.vue')
  },
  {
    path: '/upload-test',
    name: 'UploadTest',
    meta: {
      ignoreToken: true,
    },
    component: () => import('@/pages/transfrom-to-pdf/UploadTest.vue')
  }
];

export default noTokenRoutes;
